import { Delete, EditGlyph, OverflowMenu } from '@wfp/icons-react';
import { Text } from '@wfp/react';
import React, { useEffect, useRef, useState } from 'react';

const ReviewIcon = ({
  permissions,
  closed,
  user,
  activeUser,
  data,
  toggleDeleteConfirmationModal,
  toggleEdit,
  isReportPublished,
  nested = false,
  parentClosed = false,
  isCommentsUpdating,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = e => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    window.addEventListener('click', handleClickOutside);
    window.addEventListener('touchstart', handleClickOutside);
    return () => {
      window.removeEventListener('click', handleClickOutside);
      window.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  function checkIssueAnotherUserReplies() {
    const { comments } = data || {};
    let hasAnotherUserReplies = false;

    if (comments)
      comments.forEach(item => {
        if (item.user.username !== activeUser) hasAnotherUserReplies = true;
      });

    return hasAnotherUserReplies;
  }

  const {
    delete_issue,
    delete_own_issue,
    change_issue,
    change_own_issue,
    change_comment,
    change_own_comment,
    delete_own_comment,
  } = permissions;

  let displayEditIcon, displayDeleteIcon;
  if (!nested) {
    displayEditIcon =
      !closed &&
      ((!!change_own_issue && user.username === activeUser) || !!change_issue);
    displayDeleteIcon =
      !closed &&
      ((!!delete_own_issue && user.username === activeUser) ||
        !!delete_issue) &&
      (!checkIssueAnotherUserReplies() || !!delete_issue);
  } else {
    displayEditIcon =
      !parentClosed &&
      ((!!change_own_comment && user.username === activeUser) ||
        !!change_comment);
    displayDeleteIcon =
      !parentClosed && !!delete_own_comment && user.username === activeUser;
  }

  const editIcon = displayEditIcon && (
    <EditGlyph color="#71767E" className="noselect" />
  );
  const deleteIcon = displayDeleteIcon && (
    <Delete fill="#71767E" id={data.pk} className="noselect" />
  );

  if (!displayDeleteIcon && !displayEditIcon) return null;

  return (
    <div
      ref={containerRef}
      className={`dropdown${isOpen ? ' dropdown--active' : ''}`}
    >
      <a
        className="dropdown__trigger"
        onClick={e => {
          e.stopPropagation();
          setIsOpen(prev => !prev);
        }}
      >
        <OverflowMenu
          width="20"
          height="20"
          className="acr-comment-dropdown-menu"
          color="#595F65"
        />
      </a>
      {isOpen && (
        <div className="dropdown__content">
          <div>
            {displayEditIcon && !closed && (
              <div
                onClick={() => {
                  if (!isCommentsUpdating) {
                    setIsOpen(false);
                    toggleEdit();
                  }
                }}
                className="acr-comments-action"
              >
                <span>{editIcon}</span>
                <Text>Edit</Text>
              </div>
            )}
            {displayDeleteIcon && !isReportPublished && (
              <div
                onClick={toggleDeleteConfirmationModal}
                className="acr-comments-action"
              >
                <span>{deleteIcon}</span>
                <Text>Delete</Text>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewIcon;
